import axios from 'axios';

import {
  AddCsatResponseRequest,
  CsatSurveySession,
  CsatSurveyView,
  DismissCsatSurveyViewRequest,
  StartCsatSurveyRequest,
} from '../models/Csat';
import { config, createHeaders } from './index';

export const startCsatSurvey = async (
  csatSurveyView: StartCsatSurveyRequest,
  accessToken: string
) => {
  return axios.request<CsatSurveySession>({
    ...config,
    url: 'csat/view/start',
    method: 'post',
    data: { csatSurveyView },
    headers: createHeaders({ accessToken }),
  });
};

export const dismissCsatSurveyView = async (
  csatSurveyView: DismissCsatSurveyViewRequest,
  accessToken: string
) => {
  return axios.request<{ csatSurveyView: CsatSurveyView }>({
    ...config,
    url: 'csat/view/dismiss',
    method: 'post',
    data: { csatSurveyView },
    headers: createHeaders({ accessToken }),
  });
};

export const addCsatResponse = async (
  csatResponse: AddCsatResponseRequest,
  accessToken: string
) => {
  return axios.request({
    ...config,
    url: 'csat/response',
    method: 'post',
    data: { csatResponse },
    headers: createHeaders({ accessToken }),
  });
};
